
// import dynamic from "next/dynamic";
// import Head from "next/head";

// const DynamicDesktopIndia = dynamic(() =>
//   import("@/components/HomeLanding/HomeLandingPageIndia")
// );
// const DynamicMobileIndia = dynamic(() =>
//   import("@/components/HomeLanding/MobileHomeLandingPageIndia")
// );

// export default function HomeLandingIndia({ mobileView }) {
//   return (
//     <>
//        <Head>
//         <title>Modern POS Billing Software in Dubai & UAE - Start Free Today</title>
//        <meta
//           name="description"
//           content=""
//         />
//         <link rel="canonical" href="https://queuebuster.co" />
//         <link rel="alternate" href="https://queuebuster.co" hrefLang="en-us" />
//         <meta
//           property="og:title"
//           content=""
//         />
//         <meta
//           property="og:description"
//           content=""
//         />
//         <meta
//           property="og:image"
//           content=""
//         />
//       </Head>
//       {mobileView ? <DynamicMobileIndia /> : <DynamicDesktopIndia />}
//     </>
//   );
// }




import dynamic from "next/dynamic";
import Head from "next/head";
import { useEffect, useState } from "react";
import { getTitleContent } from "@/constants/common";

// const DynamicDesktop = dynamic(() =>
//   import("../components/homePage/DesktopHomePage")
// );

// const DynamicMobile = dynamic(() =>
//   import("../components/homePage/MobileHomePage")
// );
const DynamicDesktopIndia = dynamic(() =>
  import("@/components/HomeLanding/HomeLandingPageIndia")
);
const DynamicMobileIndia = dynamic(() =>
  import("@/components/HomeLanding/MobileHomeLandingPageIndia")
);
  

export default function HomeLandingIndia() {
   const [mobileView, setMobileView] = useState(undefined);
   const { merchantsCount } = getTitleContent();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setMobileView(window.innerWidth < 600);
      };
      handleResize(); // set initial value
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);
  return (
    <>
      <Head>
        <title>POS Solutions for Small, Medium & Large Businesses</title>
        <meta
          name="description"
          content={`QueueBuster is India's leading POS solutions provider, managing Billing, Inventory, Online Dukaan, CRM & Loyalty and many more. With over ${merchantsCount} makes it India's No.1 Super Business App. `}
        />
        <link rel="canonical" href="https://queuebuster.co/in-en" />
        <link rel="alternate" href="https://queuebuster.co/in-en" hrefLang="en-us" />
        <link rel="preload" href="/assets/fonts/Gilroy/Gilroy-Bold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
        <link rel="preload" href="/assets/fonts/Gilroy/Gilroy-Medium.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
        <link rel="preload" href="/assets/fonts/Gilroy/Gilroy-Semibold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
        <meta
          property="og:title"
          content="Most Powerful Point of Sale Solution for Small, Medium & Large Businesses - Get Your Free Demo, Today!"
        />
        <meta
          property="og:description"
          content="QueueBuster is India's leading POS solution streamlining businesses from small shops to large scale enterprises. We offer a comprehensive management of Billing, Inventory, Online Dukaan, CRM & Loyalty and many more."
        />
        <meta
          property="og:image"
          content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/ALL-IN-ONE_OG.jpg"
        />
        {/* D&B DUNS Registered Seal Script */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              var script = document.createElement('script');
              script.src = 'https://dunsregistered.dnb.com';
              script.type = 'text/javascript';
              document.head.appendChild(script);
            `,
          }}
        />
      </Head>
       
      {/* {mobileView ? <DynamicMobile /> : <DynamicDesktop />} */}
        {mobileView === undefined ? <DynamicDesktopIndia /> : mobileView ? <DynamicMobileIndia /> : <DynamicDesktopIndia />}
    </>
  );
}

